import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { URL } from "../../../Services/Constant";
import { post } from "../../../Services/ApiHandler";
import AlertIndTypes from "../../KnfSuperAdmin/Alert/AlertIndTypes";
import AlertIndNewEscalation from "../../KnfSuperAdmin/Alert/AlertIndEscalation";
import AlertTypesAndCamera from "../../KnfSuperAdmin/Alert/AlertTypesAndCamera";

const AlertMainCompany = ({ ind, editable, adminType, page }) => {
  const [selectedItem, setSelectedItem] = useState({});
  const [site, setSite] = useState({});
  const [comapanyList, setCompanyList] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [activeTab, setActiveTab] = useState("types");
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const location = useLocation();
  const data_admin = location?.state?.data;
  const [selected, setSelected] = useState([]);
  const [btn, setBtn] = useState(false);

  let path = location?.pathname;

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("types", JSON.stringify(type));
  };

  const getAlert = (site_id, alert_type) => {
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.SITE_ALERT_TYPES_LIST, formdata)
        .then((res) => {
          let temp = [];
          alert_type?.map((item, ind) => {
            let finder = res?.lists?.find((i) => i?.alert_type == item?.name);
            if (finder?.id) {
              temp.push({
                ...item,
                severity: finder?.severity,
              });
            } else {
              temp.push(item);
            }
          });

          if (res?.lists?.length > 0) {
            setAlertData(temp);
          } else {
            setAlertData([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlertTypes = (site_id) => {
    setSite(site_id);
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.COMPANY_ALERT_TYPES, formdata)
        .then((res) => {
          if (res?.alert_type?.length > 0) {
            // setAlertData(res?.alert_type);
            getAlert(site_id, res?.alert_type);
            if (res?.selected_alert_type_ids?.length > 0) {
              setSelected(res?.selected_alert_type_ids);
            }
          } else {
            setAlertData([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertData([]);
    }
  };

  const getAlertEscalation = (site_id) => {
    setSite(site_id);
    if (site_id) {
      let formdata = new FormData();
      formdata.append("site_id", site_id);
      post(URL.SITE_ALERT_ESCULATION_LIST, formdata)
        .then((res) => {
          if (res?.lists?.length > 0) {
            setAlertDatas(res?.lists);
          } else {
            setAlertDatas([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setAlertDatas([]);
    }
  };

  useEffect(() => {
    if (data_admin?.id) {
      getAlertTypes(data_admin?.id);
      getAlertEscalation(data_admin?.id);
    }
  }, []);

  // console.log("selected", selected);

  const selectAlertTypes = () => {
    let formdata = new FormData();
    formdata.append("site_id", data_admin?.id);
    selected?.map((item, ind) => {
      formdata.append(`alert_type_id[${ind}]`, item);
    });
    setBtn(true);
    post(URL.UPDATE_ALERT_TYPES, formdata)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
        }
        setBtn(false);
      })
      .catch((err) => {
        setBtn(false);
        console.log("err", err);
      });
  };

  return (
    <div className="mt-5 px-5">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
          onClick={() => handleTab("types")}
        >
          Alert Types
        </button>
        <button
          className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
          onClick={() => handleTab("escalation")}
        >
          Alert Escalation Time
        </button>
        {path == "/company-sites-view" && (
          <button
            className={`tab-btn ${activeTab === "camera" ? "active" : ""}`}
            onClick={() => handleTab("camera")}
          >
            Alert Types and Camera
          </button>
        )}
      </div>
      <div>
        {activeTab === "types" && (
          <AlertIndTypes
            editable={false}
            alertData={alertData}
            setAlertData={setAlertData}
            selected={selected}
            setSelected={setSelected}
            selectAlertTypes={selectAlertTypes}
            btn={btn}
            disable={true}
          />
        )}
        {activeTab === "escalation" && (
          <AlertIndNewEscalation
            editable={editable}
            site={site}
            alertData={alertDatas}
            setAlertData={setAlertDatas}
          />
        )}

        {activeTab === "camera" && (
          <AlertTypesAndCamera
            editable={false}
            site={site}
            alertData={alertData}
            setAlertData={setAlertData}
            data={data_admin}
          />
        )}
      </div>
    </div>
  );
};

export default AlertMainCompany;
